import { Box, Typography } from '@mui/material';
import type { TypographyProps } from '@mui/material';

type MemorySectionHeaderProps = {
  headerText: string;
  subHeaderText?: string;
  marginTop?: TypographyProps['mt'];
  marginBottom?: TypographyProps['mb'];
};

function MemorySectionHeader({
  headerText,
  subHeaderText,
  marginTop = 1,
  marginBottom = 2,
}: MemorySectionHeaderProps) {
  return (
    <Box mt={marginTop} mb={marginBottom}>
      <Typography
        fontFamily='Mont-semibold'
        fontSize={22}
        sx={{ height: '26px' }}
      >
        {headerText}
      </Typography>
      {subHeaderText && (
        <Typography
          variant='caption'
          sx={{
            maxWidth: '100%',
            overflowWrap: 'break-word',
            whiteSpace: 'normal',
            lineHeight: 0,
            fontSize: '14px',
          }}
        >
          {subHeaderText}
        </Typography>
      )}
    </Box>
  );
}

export default MemorySectionHeader;
